import { render, staticRenderFns } from "./item-data.vue?vue&type=template&id=14b3b2cb&"
import script from "./item-data.vue?vue&type=script&lang=js&"
export * from "./item-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports